import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  OnInit,
  inject,
} from '@angular/core';
import { SeoService } from '../../../services/seo.service';
import { HeroCarouselComponent } from '../../../components/layout/hero-carousel/hero-carousel.component';
import { statsComponent } from '../../../components/layout/stats/stats.component';
import { ExploreBySectorComponent } from '../../../components/layout/explore-by-sector/explore-by-sector.component';
import { HomeModelComponent } from '../../../components/layout/home-model/home-model.component';
import { HomeDatasetComponent } from '../../../components/layout/home-dataset/home-dataset.component';
import { FaqSectionComponent } from '../../../components/layout/faq-section/faq-section.component';
import { SpotlightComponent } from '../../../components/layout/spotlight/spotlight.component';
import { HomeUsecaseComponent } from '../../../components/layout/home-usecase/home-usecase.component';
import { pageSeoInfo } from '../../../constants/page-seo-info';
import { routes } from '../../../constants/routes';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HomeComputeComponent } from '../../../components/layout/home-compute/home-compute.component';
import { HomeToolkitsComponent } from '../../../components/layout/home-toolkits/home-toolkits.component';
import { HomeCompetitionsComponent } from '../../../components/layout/home-competitions/home-competitions.component';
import { UtilityService } from '../../../services/utility.service';
import { HomeModelTryoutComponent } from '../../../components/layout/home-model-tryout/home-model-tryout.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, skip } from 'rxjs';
import { CachingService } from '../../../services/caching.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    NgClass,
    RouterLink,
    statsComponent,
    HeroCarouselComponent,
    ExploreBySectorComponent,
    HomeModelComponent,
    HomeDatasetComponent,
    FaqSectionComponent,
    SpotlightComponent,
    FaqSectionComponent,
    HomeModelComponent,
    HomeDatasetComponent,
    HomeUsecaseComponent,
    HomeComputeComponent,
    HomeToolkitsComponent,
    HomeCompetitionsComponent,
    HomeModelTryoutComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  isSubOptionOpen = false;
  renderHomeContent = true;

  readonly routes = routes;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private seoService: SeoService,
    protected utilityService: UtilityService,
    private cachingService: CachingService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    const { title, description, canonicalUrl } = pageSeoInfo['home'];
    this.seoService.setPageTitle(title);
    this.seoService.setPageDescription(description);
    this.seoService.setCanonicalUrl(canonicalUrl);
    this.subscribeToLanguageChange();
  }

  private subscribeToLanguageChange(): void {
    this.cachingService.languageChange$
      .pipe(
        skip(1),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.refreshHomeContent();
      });
  }

  private refreshHomeContent(): void {
    this.renderHomeContent = false;
    this.cdr.detectChanges();

    setTimeout(() => {
      this.renderHomeContent = true;
      this.cdr.detectChanges();
    });
  }
}
